/**
 * attributes parsed through data- attribues
 * i.e. <div id='perlasgo-third-party-attached' data-api-key='somekey' /> will be fetched as
 * {
 *  'api-key': 'somekey'
 * }
 * */

import { EPluginAttributes, IAttributesState, IThirdPartyAttributes } from "@monorepo/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialAttributesState = {
  "attributes-object": {
    stylesObject: {},
    accessToken: "",
    parentOriginUrl: "",
    parentWholeUrl: "",
    externalPaymentUrl: "",
    canceled: false,
    orderId: "",
    imageUrls: {
      firstPayment: "",
      success: "",
      failure: "",
      paymentHistory: "",
    },
    serviceId: "",
    wasRedirected: false,
  },
} as IAttributesState;

const attributesSlice = createSlice({
  name: "attributes",
  initialState: initialAttributesState,
  reducers: {
    setAttribute: (state, action: PayloadAction<{ attribute: EPluginAttributes; value: IThirdPartyAttributes }>) => {
      return { ...state, [action.payload.attribute]: action.payload.value };
    },
  },
});

export const { setAttribute } = attributesSlice.actions;
export default attributesSlice.reducer;
